module.exports = __webpack_public_path__ + "img/p20.c21ecf50.png";